import React from "react";

const FolderOpen = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M3.561 32.444c-.414 0-.811-.166-1.104-.462A1.59 1.59 0 012 30.864V5.58c0-.419.164-.82.457-1.117C2.75 4.166 3.147 4 3.561 4h11.573l3.122 3.16h11.842c.414 0 .81.167 1.103.463.293.297.457.699.457 1.118v4.74H5.122v15.797l3.122-12.636H34l-3.606 14.606c-.084.342-.28.645-.554.862a1.549 1.549 0 01-.96.334H3.561z"
            fill={fill}
      />
    </svg>
);

export default FolderOpen;
